module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-label-group"
  }, [_c('el-checkbox-group', _vm._b({
    on: {
      "change": _vm.handelChange
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, 'el-checkbox-group', _vm.$attrs, false), [_vm._t("default", _vm._l((_vm.labelList), function(item, index) {
    return _c('rt-label-item', {
      key: index,
      attrs: {
        "label": item[_vm.valueKey]
      }
    }, [_c('span', [_vm._v(_vm._s(item[_vm.nameKey]))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../assets/imgs/check-circle-fill.png"),
        "alt": ""
      }
    })])
  }))], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f44c976c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/label/rtLabelGroup.vue
// module id = 1552
// module chunks = 91